import type {DirectMessageComposeFormValues} from "../schemas";

export function serializeDirectMessageCreatePayload(values: DirectMessageComposeFormValues) {
  const subject = values.subject?.trim();
  return {
    recipient_user_id: values.recipient.user_id,
    body: values.body.trim(),
    replies_enabled: values.replies_enabled,
    ...(subject ? {subject} : {}),
  };
}

export function serializeDirectMessageReplyPayload(body: string) {
  return {body: body.trim()};
}
